import type { JSONDocNode } from '@atlaskit/editor-json-transformer';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ReattachCommentPanelLoader: LoadableType<{
	containerId: string;
	updateDocument: (doc: JSONDocNode) => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReattachCommentPanel" */ './ReattachCommentPanel.tsx'
			)
		).ReattachCommentPanel,
});
